export default __webpack_public_path__ + "static/media/image1.d52a5bbe.jpg";